import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import SizeForm from "../forms/Size";


class Size extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      mainCats: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      subCats: [],
      tags: [],
      packages: [],
      exelFile: null,
      uploadLoading: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.size
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });


    setTimeout(() => {
      this.formRef.current.handleDidMount(product, 'taste');
    }, 0);
  };

  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  showUpload = (product = {}) => {
    this.setState({ visibleUpload: true, selected: product });

    setTimeout(() => {
      this.uploadRef.current.handleDidMount(product.id);
    }, 0);
  };

  hideUpload = () => {
    this.setState({ visibleUpload: false });

    setTimeout(() => {
      this.uploadRef.current.handleWillUnmount();
    }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  



  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.size
          .delete(record._id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    if(this.state.selected._id != undefined){
      API.size
          .update(values, this.state.selected._id)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }else{
      API.size
          .add(values)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }

  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    onSetRoute({ openKey: parentName, selectedKey: routeName });

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  }

  render() {
    const {
      data,
      filterMainCat,
      loading,
      mainCats,
      pagination,
      selected,
      subCats,
      submitting,
      tags,
      visibleDrawer,
      visibleModal,
      visibleUpload,
      exelFile,
      packages
    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    const columns = [
   

      {
        title: Resources.code,
        dataIndex: "code",
      },

    ];


    columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showModal(record)}
              />
            </Tooltip>

            <Tooltip title={Resources.delete}>
              <Button
                  type="link"
                  className="text-danger"
                  icon={<DeleteOutlined />}
                  onClick={() => this.handleDelete(record)}
              />
            </Tooltip>
          </Fragment>
        ),
      });


    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{`${Resources.sizes}`} </Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>

            <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
            </Col>
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>

        <SizeForm
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}

        />

      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(Size);
